import React from "react";
import ErrorsLayout from "..";

const PageError = () => {
  return (
    <ErrorsLayout
      title="Ocorreu um erro imprevisto"
      description="Não foi possível acessar a página solicitada, tente novamente ou contate o suporte"
    />
  );
};

export default PageError;
